var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-reminder-tag",class:("activity-reminder-tag__priority--" + _vm.priority)},[_c('small',[_vm._v(_vm._s(_vm.reminderText))]),_c('div',[_c('Icon',{attrs:{"size":12,"name":_vm.iconName}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }